module.exports = __webpack_public_path__ + "img/1.a88956d3.jpg";